import styled from "styled-components";

export const TabContainer = styled.div`
  display: flex;
  background: #f5f5f5;
  border-radius: 12px;
  padding: 8px;
  width: 100%;
`;

export const TabItem = styled.div<{ isActive: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  cursor: pointer;
  border-radius: 8px;
  background: ${({ isActive }) => (isActive ? "#1A1A1A" : "transparent")};
  transition: all 0.2s;
  &:hover {
    background: ${({ isActive }) => (isActive ? "#1A1A1A" : "#e8e8e8")};
  }
`;

export const TabIcon = styled.div<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ isActive }) => (isActive ? "#fff" : "#666")};
  img {
    height: auto;
    max-width: 100%;
  }
`;

export const TabText = styled.span<{ isActive: boolean }>`
  font-size: ${({ isActive }) => (isActive ? "14px" : "12px")};
  font-weight: ${({ isActive }) => (isActive ? "500" : "400")};
  color: ${({ isActive }) => (isActive ? "#fff" : "var(--Text-Primary-grey600, #121212)")};
  transition: color 0.2s;
`;

export const TabDivider = styled.div`
  width: 1px;
  background: #e0e0e7;
  margin: 0 8px;
`;
